export default new class Preloader {
  constructor() {
    this.preloaderClass = 'preloader_active';
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  // eslint-disable-next-line class-methods-use-this
  init() {
    // $(`.${this.preloaderClass}`).hide();
  }
}();
